<template>
    <div class="pay-channel">
        <h3>支付通道设置</h3>
        <el-form class="demo-form-inline" size="mini" label-width="180px" style="width: 640px;">
            <el-form-item label="支付通道">
                <el-select placeholder="请选择" v-model="channel">
                    <el-option v-for="item,key in payChannel" :key="key" :label="item" :value="key"></el-option>
                </el-select>
                <el-button type="primary" @click="save">保存</el-button>
            </el-form-item>
        </el-form>
        <el-dialog title="支付通道" :visible.sync="dialogVisible" width="30%">
            <span>是否确认修改支付通道</span>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="update">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import map from '../../datamap'
import api from '../api'
const {
    payChannel
} = api

export default {
    name: "payChannel",
    data() {
        return {
            channel: '',
            dialogVisible: false,
            channelList: {
                1: '云账户',
                2: '椰云',
            },
        };
    },
    computed: {
        payChannel() {
            return map.payChannel;
        }
    },
    watch: {},
    mounted() {
        this.get();
    },
    methods: {
        save() {
            if (!this.channel) {
                this.$message.error('请选择支付通道 ')
            } else {
                this.dialogVisible = true;
            } 
        },
        async get() {
            let res = await payChannel.get();
            this.channel = res.data.data.channel_id;
        },
        async update() {
            let res = await payChannel.update({channel: this.channel});  
            if (res.data.code == 200) {
                this.$message.success('更新数据成功 ')
                this.dialogVisible = false;
            } else {
                this.$message.error('更新数据失败 ')
            }
        },
    },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/setting/payway.vue